<script setup lang="ts">
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';
import { MealParticipantFragment } from '@/graphql/custom-types';
import { IProfile } from '@/interfaces';
import ParticipantsListOverlay from '@/overlays/ParticipantsListOverlay.vue';
import i18n from '@/utils/i18n';
import { computed, ref } from 'vue';

const showParticipantsOverlay = ref<boolean>(false);

interface Props {
  profiles: (IProfile | MealParticipantFragment)[];
  participantType: string;
  canTriggerOverlay?: boolean;
  borderBottom?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  canTriggerOverlay: false,
  borderBottom: true,
});

const title = computed(() => {
  return props.participantType === 'participant'
    ? i18n.global.t('global.participants', props.profiles.length)
    : i18n.global.t('global.responsible', props.profiles.length);
});

const handleClick = () => {
  if (props.canTriggerOverlay) {
    showParticipantsOverlay.value = true;
  }
};
</script>

<template>
  <div>
    <BasicBlock
      :icon="['fal', 'user-friends']"
      :ariaDescription="title"
      :text="`${profiles.length} ${title}`"
      :canTriggerOverlay="canTriggerOverlay"
      :borderBottom="borderBottom"
      typography="b600-bold"
      @click="handleClick"
    />

    <ParticipantsListOverlay
      v-if="showParticipantsOverlay"
      :title="title"
      :profiles="profiles"
      @close="showParticipantsOverlay = false"
    />
  </div>
</template>
